import React from 'react';

import { importFromS3 } from '../../utils/importFromS3';

interface IProps {
  shouldRenderNavBar: boolean
}

// Runtime dependency
const ConnectPlugin: React.FC<IProps> = React.lazy(() => importFromS3('tcc-apps-marketplace-plugin'));

export const ConnectPluginContainer = () => (
  <ConnectPlugin shouldRenderNavBar={false} />
);
